/**
 * Accounting Dashboard Page
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTransactions } from '../accountingSlice';

const AccountingDashboard = () => {
  const dispatch = useDispatch();
  const { transactions, isLoading } = useSelector((state) => state.accounting);

  useEffect(() => {
    dispatch(fetchTransactions());
  }, [dispatch]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Accounting Dashboard</h1>
        <p className="text-gray-600 dark:text-gray-400">Financial overview and transactions</p>
      </div>

      {isLoading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <p className="text-gray-500">Accounting data will be displayed here</p>
        </div>
      )}
    </div>
  );
};

export default AccountingDashboard;
